/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-09-16 08:34:34
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import { TextStyle, Tooltip, Icon } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { DesktopMajor, MobileMajor } from '@shopify/polaris-icons';

import { RenderLabelTooltip } from 'src/components/views/common/forms/render-label-tooltip';
import PreviewProduct from 'src/components/views/default-theme-settings/product-item/preview-product';
import PreviewProductList from 'src/components/views/default-theme-settings/product-item/preview-product-list';

type Props = {
  settingsStyleValues: Object
};
type ComposedProps = Props & WithI18nProps;

type State = {
  selectedDevice: string
};
class Preview extends Component<ComposedProps, State> {
  state = {
    selectedDevice: 'desktop' // 'desktop', 'mobile'
  };

  render() {
    const { settingsStyleValues, filterData, i18n, selected } = this.props;
    const { selectedDevice } = this.state;

    return (
      <div className="previewPanel">
        <div className="title">
          <RenderLabelTooltip
            label={
              <TextStyle variation="strong">
                {i18n.translate('AdminHTML.DefaultThemeSettings.Preview.cardTitle')}
              </TextStyle>
            }
            tooltip={i18n.translate('AdminHTML.DefaultThemeSettings.Preview.cardTitle_Tooltip')}
          />
        </div>
        <div className="device">
          <div className="icons">
            <Tooltip
              content={i18n.translate(
                'AdminHTML.FilterTree.Item.optionModal_Preview_TooltipPC_Content'
              )}
              preferredPosition="above">
              <span
                className={selectedDevice === 'desktop' ? 'icon active first' : 'icon first'}
                onClick={() => this.changeDevice('desktop')}>
                <Icon
                  source={DesktopMajor}
                  color={selectedDevice === 'desktop' ? 'primary' : 'base'}
                />
              </span>
            </Tooltip>
            <Tooltip
              content={i18n.translate(
                'AdminHTML.FilterTree.Item.optionModal_Preview_TooltipMobile_Content'
              )}
              preferredPosition="above">
              <span
                className={selectedDevice === 'mobile' ? 'icon active' : 'icon'}
                onClick={() => this.changeDevice('mobile')}>
                <Icon
                  source={MobileMajor}
                  color={selectedDevice === 'mobile' ? 'primary' : 'base'}
                />
              </span>
            </Tooltip>
          </div>
        </div>
        <div className="preview-content">
          {selected === 0 ? (
            <PreviewProductList settings={settingsStyleValues} filterData={filterData} />
          ) : (
            <PreviewProduct settings={settingsStyleValues} filterData={filterData} />
          )}
        </div>
      </div>
    );
  }
  changeDevice = selectedDevice => {
    const updatedState = { selectedDevice };
    this.setState(updatedState);
  };
}

const mapStateToProps = (state, props) => {
  const formDefaultThemeSettings = getFormValues('DefaultThemeSettingsForm')(state);
  const filterData = _.get(state.filterData, 'filterData', []);

  const settingsStyleValues = _.pick(formDefaultThemeSettings, [
    // General
    'general.layoutType',
    // List
    'products.productItemType',
    'products.productItemLayout',
    'products.textAlignment',
    'products.showVendor',
    'products.showPrice',
    'products.showProductReview',
    'products.showDetailWhenHover',
    'products.activeImageSwap',
    'products.aspectRatio',
    'products.aspectRatioOther',
    'products.productImgCrop',
    // Detail
    'products.productTitleColor',
    'products.productTitleSize',
    'products.productTitleTransform',
    'products.productTitleFont',
    'products.productTitleFontStyle',
    'products.productVendorColor',
    'products.productVendorSize',
    'products.productVendorTransform',
    'products.productVendorFont',
    'products.productVendorFontStyle',
    'products.productPriceColor',
    'products.productOldPriceColor',
    'products.productSalePriceColor',
    'products.productPriceFont',
    'products.productPriceFontStyle',
    'products.productPriceSize',
    // Swatch settings
    'products.swatchEnable',
    'products.showSwatchTooltip',
    'products.swatchChangeImg',
    'products.swatchByColorApply',
    'products.swatchByColorShape',
    'products.swatchByImgApply',
    'products.swatchByImgShape',
    'products.swatchByProImgApply',
    'products.swatchByProImgShape',
    'products.swatchByTextApply',
    'products.swatchByTextShape',
    'products.swatchByTextBg',
    'products.swatchByTextColor',
    'products.swatchByTextBorder',
    // Label
    'products.labelPosition',
    'products.labelType',
    'products.saleLabelEnable',
    'products.saleLabelDisplay',
    'products.saleLabelBg',
    'products.saleLabelText',
    'products.saleLabelImg',
    'products.soldOutEnable',
    'products.soldOutDisplay',
    'products.soldOutBg',
    'products.soldOutText',
    'products.soldOutImg',
    'products.tagLabelEnable',
    'products.tagLabelBg',
    'products.tagLabelText'
  ]);

  return {
    settingsStyleValues,
    filterData
  };
};

export default connect(mapStateToProps)(withI18n()(Preview));
